export const getDateRange = (timeRange: string, customStartDate?: string, customEndDate?: string) => {
  const today = new Date();
  let fromDate = new Date();
  let toDate = new Date();

  switch (timeRange) {
    case "Yesterday":
      fromDate.setDate(today.getDate() - 1);
      toDate.setDate(today.getDate() - 1);
      break;
    case "Last Week":
      fromDate.setDate(today.getDate() - 7);
      break;
    case "Last Month":
      fromDate.setDate(today.getDate() - 30);
      break;
    case "180 days":
      fromDate.setDate(today.getDate() - 180);
      break;
    case "CustomizeDate":
      if (customStartDate && customEndDate) {
        fromDate = new Date(customStartDate);
        toDate = new Date(customEndDate);
      }
      break;
    default:
      break;
  }

  const formatDate = (date: Date) => {
    return date.getFullYear() + "-" + 
           String(date.getMonth() + 1).padStart(2, "0") + "-" + 
           String(date.getDate()).padStart(2, "0");
  };

  return {
    from: timeRange === "CustomizeDate" && customStartDate ? customStartDate : formatDate(fromDate),
    to: timeRange === "CustomizeDate" && customEndDate ? customEndDate : formatDate(toDate),
  };
};

export const formatOrderDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
